import { render, staticRenderFns } from "./BtnExcluirDocumento.vue?vue&type=template&id=41867df4&"
import script from "./BtnExcluirDocumento.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports